export const CONFIGURATION_CANVAS_LEFT_PANEL_WIDTH = 380;
export const CONFIGURATION_CANVAS_RIGHT_PANEL_WIDTH = 380;
